export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.4.20-0941.33",
  commitId: "b375d426a2e0027fc0fafd14c13da7b085c8b098",
  commitTime: "2026-04-20T09:41:33.000Z",
});
